export function isFirefox(): boolean {
  if (typeof navigator !== 'undefined') {
    return navigator.userAgent.includes('Firefox');
  }
  return false;
}
